import React, { useEffect, useState } from "react";
import LocationImg from "./images/location.png";
import ClearImg from "./images/sun.png";
import HazeImg from "./images/haze.png";
import RainImg from "./images/rain.png";
import SnowImg from "./images/snow.png";
import CloudImg from "./images/cloudy.png";
import WindImg from "./images/windsock.png";
import TempImg from "./images/temperature.png";
import HumidImg from "./images/humidity.png";
import EyeImg from "./images/visibility.png";
import AirImg from "./images/air-transmission.png";
export default function WheatherCard(props) {
  const [place, setPlace] = useState("");
  const [mainData, setmainData] = useState("");
  const [Wheather, setWheather] = useState("");
  const [jsonData, setjsonData] = useState("");
  const [riseTime,setriseTime] = useState("");

  const getPlace = (event) => {
    setPlace(event.target.value);
  };
  const getUpdates = async () => {
    const url = `https://api.openweathermap.org/data/2.5/weather?q=${place}&appid=${props.apiKey}`;
    let data = await fetch(url);
    let parsedData = await data.json();
    setWheather(parsedData.weather[0].main);
    setmainData(parsedData.main);
    setjsonData(parsedData);
  };


  return (
    
    <div
      className={`WheatherCard text-${
        props.mode === "light" ? "dark" : "light"
      }`}
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 my-3">
            <h3 style={{ textAlign: "center" }}>Get the Wheather Updates</h3>
            <div class="d-flex justify-content-center">
              <div class="mb-3 w-50 ">
                <label for="exampleFormControlInput1" class="form-label">
                  Place
                </label>
                <input
                  type="text"
                  class={`form-control bg-${props.mode} text-${
                    props.mode === "light" ? "dark" : "light"
                  }`}
                  id="Place"
                  placeholder="Eg:Hyderabad"
                  value={place}
                  onChange={getPlace}
                />
                <button
                  type="button"
                  onClick={getUpdates}
                  class={`btn btn-${
                    props.mode === "light" ? "dark" : "light"
                  } my-4`}
                >
                  Get Updates
                </button>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 my-3">
            <div class="card text-bg-dark mb-3" style={{ maxWidth: "18rem" }}>
              <div class="card-header">
                <img src={LocationImg} style={{ height: "32px" }} />
                {jsonData.name}
              </div>
              <div class="card-body">
                <img
                  src={
                    Wheather === "Clear"
                      ? ClearImg
                      : Wheather === "Haze"
                      ? HazeImg
                      : Wheather === "Rain"
                      ? RainImg
                      : Wheather === "Snow"
                      ? SnowImg
                      : Wheather === "Clouds"
                      ? CloudImg
                      : CloudImg
                  }
                  style={{ height: "64px" }}
                />
                <h5 class="card-title">
                  <span style={{ fontSize: "50px", fontWeight: "200" }}>
                    {parseInt(mainData.temp - 273.15)}°C{" "}
                  </span>
                  {Wheather}
                </h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 my-3">
            <div class="card text-bg-dark mb-3" style={{ maxWidth: "18rem" }}>
              <div class="card-header">Wind Speed</div>
              <div class="card-body">
                <img src={WindImg} style={{ height: "64px" }}/>
                <h5 class="card-title"><span style={{ fontSize: "50px", fontWeight: "200" }}>{jsonData?parseInt(jsonData.wind.speed*3.6):"NaN"}</span> Kmph</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 my-3">
            <div class="card text-bg-dark mb-3" style={{ maxWidth: "18rem" }}>
              <div class="card-header">Feels Like</div>
              <div class="card-body">
                <img src={TempImg} style={{ height: "64px" }}/>
                <h5 class="card-title"><span style={{ fontSize: "50px", fontWeight: "200" }}>{parseInt(mainData.feels_like - 273.15)}</span>°C</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 my-3">
            <div class="card text-bg-dark mb-3" style={{ maxWidth: "18rem" }}>
              <div class="card-header">Humidity</div>
              <div class="card-body">
                <img src={HumidImg} style={{ height: "64px" }}/>
                <h5 class="card-title"><span style={{ fontSize: "50px", fontWeight: "200" }}>{parseInt(mainData.humidity)}</span>%</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 my-3">
            <div class="card text-bg-dark mb-3" style={{ maxWidth: "18rem" }}>
              <div class="card-header">visibility</div>
              <div class="card-body">
                <img src={EyeImg} style={{ height: "64px" }}/>
                <h5 class="card-title"><span style={{ fontSize: "50px", fontWeight: "200" }}>{parseInt(jsonData.visibility/1000)}</span>Km</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 my-3">
            <div class="card text-bg-dark mb-3" style={{ maxWidth: "18rem" }}>
              <div class="card-header">Air pressure</div>
              <div class="card-body">
                <img src={AirImg} style={{ height: "64px" }}/>
                <h5 class="card-title"><span style={{ fontSize: "50px", fontWeight: "200" }}>{parseInt(mainData.pressure)}</span>hPa</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
